import { Controller } from 'stimulus';

// Link Document modal: fills the Revision select from the JSON map of
// document id -> [[revision id, label, latest?], ...] carried on the form,
// defaulting to the latest revision (or the linked one when editing).
export default class extends Controller {
  static targets = ['document', 'revision', 'help'];

  connect() {
    this.revisions = JSON.parse(this.data.get('revisions') || '{}');
    this.selected = this.data.get('selected') || null;
    this.fill();
  }

  documentChanged() {
    this.fill();
  }

  fill() {
    if (!this.hasRevisionTarget) return;

    const select = this.revisionTarget;
    const docId = this.documentTarget.value;
    const revisions = this.revisions[docId] || [];
    select.innerHTML = '';

    if (!docId) {
      select.disabled = true;
      this.note('Pick a document first.');
      return;
    }
    if (revisions.length === 0) {
      select.add(new Option('No revisions yet', ''));
      select.disabled = true;
      this.note('This document has no revisions yet. The link is kept without one.');
      return;
    }

    revisions.forEach(([id, label, latest]) => {
      const option = new Option(latest ? `${label} (latest)` : label, id);
      option.selected = this.selected ? String(id) === String(this.selected) : latest;
      select.add(option);
    });
    select.disabled = false;
    this.selected = null;
    this.note('Defaults to the latest revision. Pick an older one only when the work was done against it.');
  }

  note(text) {
    if (this.hasHelpTarget) this.helpTarget.textContent = text;
  }
}
